const Condition = require('./Condition');
const BattleCalc = require('../BattleCalc');

const DefensiveStanceCondition = function (
  instigator,
  owner,
  battleState,
  potency
) {
  let extant = BattleCalc.getCondition(owner, 'defensive_stance');
  if (extant) {
    return extant;
  } else {
    extant = BattleCalc.getCondition(owner, 'offensive_stance');
    if (extant) {
      battleState.expireCondition(extant.uid);
    } else {
      const condition = new Condition(instigator, owner, battleState, potency);
      condition.handle = 'defensive_stance';
      return condition;
    }
  }
};
module.exports = DefensiveStanceCondition;
